import {NgModule} from '@angular/core';
import {LabResultsStorage} from './lab-results-storage';
import { LabResultsSortInfo } from './lab-test-sort-info';

@NgModule({
    providers: [LabResultsStorage, LabResultsSortInfo]
})
export class LabTestResultModule { }